module.exports = __webpack_public_path__ + "static/media/bolso (14).e52b2fd6.jpg";